import { ISOCountryCode } from './ISOCountryCode';
import { isISOCountryCode, parseCountryCode } from './ISOCountryHelper';

const FLAGLESS_COUNTRY_CODES: ReadonlySet<ISOCountryCode> = new Set([
  ISOCountryCode.Taiwan,
  ISOCountryCode.HongKong,
]);

export function isCountryFlagHidden(countryCode: string): boolean {
  return (
    isISOCountryCode(countryCode) &&
    FLAGLESS_COUNTRY_CODES.has(parseCountryCode(countryCode))
  );
}
